namespace SPA
{
	export namespace Realtor
	{
		export class DocumentModel extends Backbone.Model
		{
			public constructor(attributes?: IDocument, options?: any)
			{
				super(attributes, options);

				console.log(attributes, options);
			}

			public initialize(attributes?: any, options?: any): void {
				attributes.filename = 'assets/images/placeholder-image.png';
			}

			public parse(data, options)
			{
				console.log("Parse", data, options);
			}

		}
	}
}